import hebcal from 'hebcal'

export default {
    hebcal: hebcal,
};


